if (!customElements.get('lm-flavour-guide')) {
  customElements.define('lm-flavour-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const chapters = Array.from(this.querySelectorAll('[data-lmsg-chapter]'));
      const links = Array.from(this.querySelectorAll('[data-lmsg-toc]'));
      const progress = this.querySelector('[data-lmsg-progress]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const update = () => {
        this.frame = null;
        const top = this.getBoundingClientRect().top + window.scrollY;
        const distance = Math.max(1, this.offsetHeight - window.innerHeight);
        if (progress) progress.style.transform = `scaleX(${Math.min(1, Math.max(0, (window.scrollY - top) / distance))})`;
        let current = chapters[0];
        for (const chapter of chapters) {
          if (chapter.getBoundingClientRect().top <= 190) current = chapter;
        }
        for (const link of links) {
          if (current && link.hash === `#${current.id}`) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }
      };
      const schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      this.addEventListener('click', event => {
        const anchor = event.target.closest('a[href^="#"]');
        if (!anchor || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const id = anchor.getAttribute('href').slice(1);
        const target = Array.from(this.querySelectorAll('[id]')).find(element => element.id === id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        try { history.replaceState(null, '', `#${encodeURIComponent(id)}`); } catch (_) {}
      }, { signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
